/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import apiService from '@services/apiService';

// const CREATE_DISCARD_CHANGES_CLICKED = 'CREATE_DISCARD_CHANGES_CLICKED';
// const EDIT_DISCARD_CHANGES_CLICKED = 'EDIT_DISCARD_CHANGES_CLICKED';
const CLEAR_REPEATABLE_SECTION_COUNT = 'CLEAR_REPEATABLE_SECTION_COUNT';
const DELETE_SUPPLEMENT = 'DELETE_SUPPLEMENT';
const FORM_SUBMITTED = 'FORM_SUBMITTED';
const GET_ALL_LISTINGS = 'GET_ALL_LISTINGS';
const HOME_BUTTON_CLICKED = 'HOME_BUTTON_CLICKED';
const LISTING_COORDS_CLEARED = 'LISTING_COORDS_CLEARED';
const LISTING_COORDS_LOADED = 'LISTING_COORDS_LOADED';
const LOAD_FORM_DEFINITION = 'LOAD_FORM_DEFINITION';
const LOAD_MY_LISTINGS = 'LOAD_MY_LISTINGS';
const LOAD_MY_LISTINGS_FAIL = 'LOAD_MY_LISTINGS_FAIL';
const LOAD_MY_LISTINGS_SUCCESS = 'LOAD_MY_LISTINGS_SUCCESS';
const LOAD_LISTING = 'LOAD_LISTING';
const LOAD_LISTING_FAIL = 'LOAD_LISTING_FAIL';
const LOAD_LISTING_SUCCESS = 'LOAD_LISTING_SUCCESS';
const LOAD_LISTING_PREFERRED_PHOTO_DETAILS = 'LOAD_LISTING_PREFERRED_PHOTO_DETAILS';
const LOAD_LISTING_PREFERRED_PHOTO_DETAILS_FAIL = 'LOAD_LISTING_PREFERRED_PHOTO_DETAILS_FAIL';
const LOAD_LISTING_PREFERRED_PHOTO_DETAILS_SUCCESS = 'LOAD_LISTING_PREFERRED_PHOTO_DETAILS_SUCCESS';
const LOAD_LISTING_PHOTO = 'LOAD_LISTING_PHOTO';
const LOAD_LISTING_PHOTO_FAIL = 'LOAD_LISTING_PHOTO_FAIL';
const LOAD_LISTING_PHOTO_SUCCESS = 'LOAD_LISTING_PHOTO_SUCCESS';
const LOAD_UPLOADED_PHOTOS = 'LOAD_UPLOADED_PHOTOS';
const REORDER_SUPPLEMENTS = 'REORDER_SUPPLEMENTS';
const SAVE_IMAGES = 'SAVE_IMAGES';
const SAVE_SUPPLEMENT = 'SAVE_SUPPLEMENT';
const SAVE_SUPPLEMENT_SUCCESS = 'SAVE_SUPPLEMENT_SUCCESS';
const SAVE_SUPPLEMENT_FAIL = 'SAVE_SUPPLEMENT_FAIL';
const SEARCH_LISTINGS = 'SEARCH_LISTINGS';
const SEARCH_LISTINGS_FAIL = 'SEARCH_LISTINGS_FAIL';
const SEARCH_LISTINGS_SUCCESS = 'SEARCH_LISTINGS_SUCCESS';
const SEARCH_LISTINGS_PAGE_CLICKED = 'SEARCH_LISTINGS_PAGE_CLICKED';
const SEARCH_LISTINGS_CRITERIA = 'SEARCH_LISTINGS_CRITERIA';
const SET_SECTION_COUNT = 'SET_SECTION_COUNT';
const TAX_AUTO_POP_SEARCH = 'TAX_AUTO_POP_SEARCH';
const TAX_AUTO_POP_SEARCH_FAIL = 'TAX_AUTO_POP_SEARCH_FAIL';
const TAX_AUTO_POP_SEARCH_SUCCESS = 'TAX_AUTO_POP_SEARCH_SUCCESS';
const TAX_AUTO_POP_SELECT = 'TAX_AUTO_POP_SELECT';
const TAX_AUTO_POP_SELECT_FAIL = 'TAX_AUTO_POP_SELECT_FAIL';
const TAX_AUTO_POP_SELECT_SUCCESS = 'TAX_AUTO_POP_SELECT_SUCCESS';
const UPLOAD_IMAGE = 'UPLOAD_IMAGE';
const UPLOAD_IMAGE_FAIL = 'UPLOAD_IMAGE_FAIL';
const VIEW_LISTING_CLICKED = 'VIEW_LISTING_CLICKED';

const CHECK_AUTOSAVE_LISTING = 'p9/listing/CHECK_AUTOSAVE_LISTING';
const CHECK_AUTOSAVE_LISTING_FAIL = 'p9/listing/CHECK_AUTOSAVE_LISTING_FAIL';
const CHECK_AUTOSAVE_LISTING_SUCCESS = 'p9/listing/CHECK_AUTOSAVE_LISTING_SUCCESS';

const LOAD_AUTOSAVE_LISTING = 'p9/listing/LOAD_AUTOSAVE_LISTING';
const LOAD_AUTOSAVE_LISTING_FAIL = 'p9/listing/LOAD_AUTOSAVE_LISTING_FAIL';
const LOAD_AUTOSAVE_LISTING_SUCCESS = 'p9/listing/LOAD_AUTOSAVE_LISTING_SUCCESS';

const REMOVE_AUTOSAVE_LISTING = 'p9/listing/REMOVE_AUTOSAVE_LISTING';
const REMOVE_AUTOSAVE_LISTING_FAIL = 'p9/listing/REMOVE_AUTOSAVE_LISTING_FAIL';
const REMOVE_AUTOSAVE_LISTING_SUCCESS = 'p9/listing/REMOVE_AUTOSAVE_LISTING_SUCCESS';

const SAVE_AUTOSAVE_LISTING = 'p9/listing/SAVE_AUTOSAVE_LISTING';
const SAVE_AUTOSAVE_LISTING_FAIL = 'p9/listing/SAVE_AUTOSAVE_LISTING_FAIL';
const SAVE_AUTOSAVE_LISTING_SUCCESS = 'p9/listing/SAVE_AUTOSAVE_LISTING_SUCCESS';

const UPDATE_AUTOSAVE_LISTING = 'p9/listing/UPDATE_AUTOSAVE_LISTING';
const UPDATE_AUTOSAVE_LISTING_FAIL = 'p9/listing/UPDATE_AUTOSAVE_LISTING_FAIL';
const UPDATE_AUTOSAVE_LISTING_SUCCESS = 'p9/listing/UPDATE_AUTOSAVE_LISTING_SUCCESS';

const RELOAD_LISTING_CLICKED = 'p9/listing/RELOAD_LISTING_CLICKED';
const RELOAD_LISTING_CLICKED_FAIL = 'p9/listing/RELOAD_LISTING_CLICKED_FAIL';
const RELOAD_LISTING_CLICKED_SUCCESS = 'p9/listing/RELOAD_LISTING_CLICKED_SUCCESS';

const LOAD_LISTING_PHOTO_SORTORDER = 'p9/listing/LOAD_LISTING_PHOTO_SORTORDER';
const CLEAR_LISTING_PHOTO_SORTORDER = 'p9/listing/CLEAR_LISTING_PHOTO_SORTORDER';

const DECREMENT_UPLOADS_COUNTER = 'p9/listing/DECREMENT_UPLOADS_COUNTER';
const SET_UPLOADS_COUNTER = 'p9/listing/SET_UPLOADS_COUNTER';

const SET_IS_BUSY = 'p9/listing/SET_IS_BUSY';

const TOGGLE_SHOW_BROKER_LISTINGS = 'TOGGLE_SHOW_BROKER_LISTINGS';

// TODO: Break images and supplements into their own reducers?

const initialState = {
  allListings: null,
  autoPopListings: null,
  autoSaveCheckLoading: false,
  autoSaveData: null,
  autoSaveExists: false,
  currentImages: [],
  editableListingLoading: true,
  loadError: null,
  repeatableSectionCount: {},
  listingClicked: null,
  listingCoordinates: null,
  listingPreferredPhotoDetails: null,
  listingPhoto: null,
  listingPhotoSortOrder: [],
  myListings: null,
  searchCriteria: null,
  searchListingsResults: null,
  selectedListing: null,
  uploadedPhotos: [],
  uploadedSupplements: [],
  searchLoading: false,
  selectLoading: false,
  sectionAddClicks: {},
  filesToBeUploadedCounter: 0,
  isBusy: false,
  showBrokerListings: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHECK_AUTOSAVE_LISTING:
      return {
        ...state,
        autoSaveCheckLoading: true,
        autoSaveData: null,
        autoSaveExists: false,
      };
    case CHECK_AUTOSAVE_LISTING_FAIL:
      return {
        ...state,
        autoSaveCheckLoading: false,
        autoSaveData: null,
        autoSaveExists: false,
      };
    case CHECK_AUTOSAVE_LISTING_SUCCESS:
      return {
        ...state,
        autoSaveCheckLoading: false,
        autoSaveData: action.payload.autoSaveData,
        autoSaveExists: action.payload.autoSaveExists,
      };
    case CLEAR_REPEATABLE_SECTION_COUNT:
      return {
        ...state,
        repeatableSectionCount: {},
      };
    case DELETE_SUPPLEMENT: {
      // find entry with matching uid and flip IsDeleted flag to true
      const insert = state.uploadedSupplements.map(file => {
        if (file.uid === action.payload) {
          return {
            ...file,
            IsDeleted: true,
          };
        }
        return file;
      });
      return {
        ...state,
        uploadedSupplements: [
          ...insert,
        ],
      };
    }
    case FORM_SUBMITTED:
      return {
        ...state,
        listingClicked: null,
        listingPreferredPhotoDetails: null,
        listingPhoto: null,
      };
    case LISTING_COORDS_CLEARED:
      return {
        ...state,
        listingCoordinates: null,
      };
    case LISTING_COORDS_LOADED:
      return {
        ...state,
        listingCoordinates: action.payload,
      };
    case GET_ALL_LISTINGS:
      return {
        ...state,
        allListings: action.error ? null : action.payload,
      };
    case HOME_BUTTON_CLICKED:
      return {
        ...initialState,
        myListings: state.myListings,
      };
    case LOAD_AUTOSAVE_LISTING:
    case REMOVE_AUTOSAVE_LISTING:
    case SAVE_AUTOSAVE_LISTING:
    case UPDATE_AUTOSAVE_LISTING:
    case LOAD_LISTING:
    case LOAD_LISTING_PREFERRED_PHOTO_DETAILS:
    case LOAD_LISTING_PHOTO:
    case TAX_AUTO_POP_SELECT:
      return {
        ...state,
        selectLoading: true,
      };
    case LOAD_AUTOSAVE_LISTING_FAIL:
    case REMOVE_AUTOSAVE_LISTING_FAIL:
    case SAVE_AUTOSAVE_LISTING_FAIL:
    case UPDATE_AUTOSAVE_LISTING_FAIL:
    case LOAD_LISTING_FAIL:
    case LOAD_LISTING_PREFERRED_PHOTO_DETAILS_FAIL:
    case LOAD_LISTING_PHOTO_FAIL:
    case TAX_AUTO_POP_SELECT_FAIL:
      return {
        ...state,
        selectLoading: false,
      };
    case LOAD_MY_LISTINGS:
      return {
        ...state,
        editableListingLoading: true,
      };
    case LOAD_MY_LISTINGS_SUCCESS:
      return {
        ...state,
        myListings: action.payload.myListings,
        editableListingLoading: false,
      };
    case LOAD_MY_LISTINGS_FAIL:
      return {
        ...state,
        editableListingLoading: true,
      };
    case LOAD_LISTING_SUCCESS:
    case TAX_AUTO_POP_SELECT_SUCCESS:
      return {
        ...state,
        selectedListing: action.payload.listingSelected,
        selectLoading: false,
      };
    case LOAD_AUTOSAVE_LISTING_SUCCESS:
      return {
        ...state,
        selectedListing: action.payload.listingSelected,
        autoSaveExists: true,
        selectLoading: false,
      };
    case LOAD_FORM_DEFINITION:
      return {
        ...state,
        autoPopListings: null,
        autoSaveData: null,
        autoSaveExists: false,
        currentImages: [],
        repeatableSectionCount: {},
        loadError: null,
        listingCoordinates: null,
        listingPhoto: null,
        listingPreferredPhotoDetails: null,
        searchCriteria: null,
        searchListingsResults: null,
        searchLoading: false,
        selectedListing: null,
        selectLoading: false,
        uploadedPhotos: [],
        uploadedSupplements: [],
      };
    case LOAD_LISTING_PREFERRED_PHOTO_DETAILS_SUCCESS:
      return {
        ...state,
        listingPreferredPhotoDetails: action.payload,
        selectLoading: false,
      };
    case LOAD_LISTING_PHOTO_SUCCESS:
      return {
        ...state,
        listingPhoto: action.payload,
        selectLoading: false,
      };
    case LOAD_UPLOADED_PHOTOS:
      return {
        ...state,
        uploadedPhotos: [...action.payload],
      };
    case LOAD_LISTING_PHOTO_SORTORDER:
      return {
        ...state,
        listingPhotoSortOrder: action.payload,
      };
    case CLEAR_LISTING_PHOTO_SORTORDER:
      return {
        ...state,
        listingPhotoSortOrder: [],
      };
    case RELOAD_LISTING_CLICKED_SUCCESS:
      return {
        ...state,
        listingClicked: action.payload.listingSearchResults,
        listingPreferredPhotoDetails: null,
        listingPhoto: null,
      };
    case REMOVE_AUTOSAVE_LISTING_SUCCESS:
      return {
        ...state,
        autoSaveData: null,
        autoSaveExists: false,
        selectLoading: false,
      };
    case REORDER_SUPPLEMENTS:
      return {
        ...state,
        uploadedSupplements: [
          ...action.payload,
        ],
      };
    case SAVE_AUTOSAVE_LISTING_SUCCESS:
    case UPDATE_AUTOSAVE_LISTING_SUCCESS:
      return {
        ...state,
        autoSaveExists: true,
        selectLoading: false,
      };
    case SAVE_IMAGES:
      return {
        ...state,
        currentImages: action.error ? null : action.currentImages,
      };
    case SAVE_SUPPLEMENT:
      return {
        ...state,
        // insert placeholder
        uploadedSupplements: [
          ...state.uploadedSupplements,
          action.payload,
        ],
        loadError: null,
      };
    case SAVE_SUPPLEMENT_FAIL:
      return {
        ...state,
        loadError: action.payload,
      };
    case SAVE_SUPPLEMENT_SUCCESS: {
      // replace placeholder data with async result
      const insert = state.uploadedSupplements.map(placeholder => ((placeholder.uid === action.payload.uid) ? action.payload : placeholder));
      return {
        ...state,
        uploadedSupplements: [
          ...insert,
        ],
      };
    }
    case SEARCH_LISTINGS:
      return {
        ...state,
        searchLoading: true,
      };
    case SEARCH_LISTINGS_FAIL:
      return {
        ...state,
        searchLoading: false,
      };
    case SEARCH_LISTINGS_SUCCESS:
      return {
        ...state,
        searchListingsResults: action.error ? null : action.payload.listingSearchResults,
        searchLoading: false,
      };
    case SEARCH_LISTINGS_CRITERIA:
      return {
        ...state,
        searchCriteria: action.error ? null : action.payload,
      };
    case SEARCH_LISTINGS_PAGE_CLICKED:
      return {
        ...state,
        autoPopListings: null,
        autoSaveData: null,
        autoSaveExists: false,
        repeatableSectionCount: {},
        selectedListing: null,
        searchListingsResults: null,
      };
    case SET_SECTION_COUNT:
      return {
        ...state,
        repeatableSectionCount: action.error ? null : action.payload,
      };
    case TAX_AUTO_POP_SEARCH:
      return {
        ...state,
        searchLoading: true,
      };
    case TAX_AUTO_POP_SEARCH_FAIL:
      return {
        ...state,
        searchLoading: false,
      };
    case TAX_AUTO_POP_SEARCH_SUCCESS:
      return {
        ...state,
        autoPopListings: action.payload.autoPopListings,
        searchLoading: false,
      };
    case VIEW_LISTING_CLICKED:
      return {
        ...state,
        listingClicked: action.error ? null : action.data,
        listingPreferredPhotoDetails: null,
        listingPhoto: null,
      };
    case UPLOAD_IMAGE: {
      const imageUploads = state.uploadedPhotos
        ? [...state.uploadedPhotos, action.payload] : [action.payload];
      return {
        ...state,
        uploadedPhotos: imageUploads,
      };
    }
    case UPLOAD_IMAGE_FAIL: {
      return {
        ...state,
        loadError: action.error,
      };
    }
    case DECREMENT_UPLOADS_COUNTER: {
      return {
        ...state,
        filesToBeUploadedCounter: state.filesToBeUploadedCounter - 1,
      };
    }
    case SET_UPLOADS_COUNTER: {
      return {
        ...state,
        filesToBeUploadedCounter: action.payload,
      };
    }
    case SET_IS_BUSY: {
      return {
        ...state,
        isBusy: action.payload,
      };
    }
    case TOGGLE_SHOW_BROKER_LISTINGS:
      return {
        ...state,
        showBrokerListings: action.payload,
      };
    default:
      return state;
  }
};

const saveCurrentCoordinates = currCords => ({
  type: LISTING_COORDS_LOADED,
  payload: currCords,
});

const saveCurrentImages = images => ({
  type: SAVE_IMAGES,
  currentImages: images,
});

// consumes a single file: uses a placeholder to maintain upload/dnd order, then inserts S3 response upon resolution
const saveSupplement = (file, id) => async dispatch => {
  // dispatch placeholder in case async promises resolve out of order
  dispatch({
    type: SAVE_SUPPLEMENT,
    // object shape must be consistent between placeholder and S3 response, for rendering purposes
    payload: {
      Path: null,
      MediaType: null,
      URL: null,
      IsError: false,
      IsDeleted: false, // necessary for posting supplement in listing form
      IsUploading: true, // for user feedback (spinner)
      uid: id,
    },
  });
  try {
    // API requires formData object
    const fileAsForm = new FormData();
    fileAsForm.append('file', file);

    // POST to S3
    const result = await apiService.Listing.SaveSupplement(fileAsForm);
    dispatch({
      type: SAVE_SUPPLEMENT_SUCCESS,
      payload: {
        Path: result.displayName,
        MediaType: result.extension,
        URL: result.newName,
        Description: result.displayName,
        IsError: result.isError,
        IsDeleted: false,
        IsUploading: false,
        uid: id,
      },
    });
  } catch (error) {
    console.error('Error: Listing fileAsForm', error);
    dispatch({
      type: SAVE_SUPPLEMENT_FAIL,
      payload: error,
    });
  }
};

const reorderSupplements = newSortOrder => ({
  type: REORDER_SUPPLEMENTS,
  payload: newSortOrder,
});

const deleteSupplement = uid => ({
  type: DELETE_SUPPLEMENT,
  payload: uid,
});

const setSearchCriteria = values => ({
  type: SEARCH_LISTINGS_CRITERIA,
  payload: values,
});

const setRepeatableSectionCount = values => async dispatch => {
  const sectionCounts = {};
  if (values.Rooms) {
    sectionCounts.Rooms = Object.keys(values.Rooms).map(key => values.Rooms[key].IsDeleted);
  }
  if (values.Photos) {
    sectionCounts.Photos = Object.keys(values.Photos).map(key => values.Photos[key].IsDeleted);
  }
  if (values.Supplements) {
    sectionCounts.Supplements = Object.keys(values.Supplements).map(key => values.Supplements[key].IsDeleted);
  }
  if (values.OpenHouses) {
    sectionCounts.OpenHouses = Object.keys(values.OpenHouses).map(key => values.OpenHouses[key].IsDeleted);
  }
  if (values.Doors) {
    sectionCounts.Doors = Object.keys(values.Doors).map(key => values.Doors[key].IsDeleted);
  }
  if (values.Parcels) {
    sectionCounts.Parcels = Object.keys(values.Parcels).map(key => values.Parcels[key].IsDeleted);
  }
  if (values.Units) {
    sectionCounts.Units = Object.keys(values.Units).map(key => values.Units[key].IsDeleted);
  }
  if (values.History) {
    sectionCounts.History = Object.keys(values.History).map(key => values.History[key].IsDeleted);
  }
  dispatch({
    type: SET_SECTION_COUNT,
    payload: sectionCounts,
  });
};

const clearRepeatableSectionCount = () => async dispatch => {
  dispatch({
    type: CLEAR_REPEATABLE_SECTION_COUNT,
  });
};

const saveListingImages = uploadedPhotos => async dispatch => {
  const newUploadedPhotos = uploadedPhotos.map(photo => [photo]);

  dispatch({
    type: LOAD_UPLOADED_PHOTOS,
    payload: newUploadedPhotos,
  });
};

const setUploadsCounter = uploadsCounter => ({
  type: SET_UPLOADS_COUNTER,
  payload: uploadsCounter,
});

const setIsBusy = value => ({
  type: SET_IS_BUSY,
  payload: value,
});

// imageKey added as a parameter to unify frontennd state with backend status
// sortOrder is used to maintain list placement for modified images after saving
const postCurrentImages = (form, imageKey, sortOrder) => async dispatch => {
  try {
    const result = await apiService.Photos.postImage(form);
    result.forEach(res => {
      if (res.path.includes('_thumbnail')) return;
      res.key = imageKey;
      if (sortOrder) res.SortOrder = sortOrder;
    });

    dispatch({
      type: UPLOAD_IMAGE,
      payload: result,
    });
    dispatch({
      type: DECREMENT_UPLOADS_COUNTER,
    });
  } catch (error) {
    console.error('Error: Listing postCurrentImages', error);
    dispatch({
      type: UPLOAD_IMAGE_FAIL,
      payload: error,
    });
  }
};

const viewListing = displayListing => ({
  type: VIEW_LISTING_CLICKED,
  data: displayListing,
});

const loadMyListings = () => async dispatch => {
  dispatch({ type: LOAD_MY_LISTINGS });
  try {
    const myListings = await apiService.Listing.GetMyListings();
    dispatch({
      type: LOAD_MY_LISTINGS_SUCCESS,
      payload: { myListings },
    });
  } catch (error) {
    console.error('Error: Listing viewListing', error);
    dispatch({ type: LOAD_MY_LISTINGS_FAIL });
  }
};

/*
 Dispatch to retrieve listing by its UniqueID value
*/
const loadListingById = uniqueID => async dispatch => {
  dispatch({ type: LOAD_LISTING });
  try {
    const listingSelected = await apiService.Listing.GetListingById(uniqueID);
    dispatch({
      type: LOAD_LISTING_SUCCESS,
      payload: { listingSelected },
    });
  } catch (error) {
    console.error('Error: Listing loadListingById', error);
    dispatch({ type: LOAD_LISTING_FAIL });
  }
};

const loadListingToCopyById = uniqueID => async dispatch => {
  dispatch({ type: LOAD_LISTING });
  try {
    const listingSelected = await apiService.Listing.CopyListing(uniqueID);
    dispatch({
      type: LOAD_LISTING_SUCCESS,
      payload: { listingSelected },
    });
  } catch (error) {
    console.error('Error: Listing loadListingToCopyById', error);
    dispatch({ type: LOAD_LISTING_FAIL });
  }
};

/*
 Retrieves the listing preferred photo details by using the listing UniqueID
*/
const loadListingPreferredPhotoDetails = uniqueID => async dispatch => {
  dispatch({ type: LOAD_LISTING_PREFERRED_PHOTO_DETAILS });
  try {
    const listingPreferredPhotoDetails = await apiService.Photos.getPreferredPhoto(uniqueID);
    dispatch({
      type: LOAD_LISTING_PREFERRED_PHOTO_DETAILS_SUCCESS,
      payload: listingPreferredPhotoDetails,
    });
  } catch (error) {
    console.error('Error: Listing loadListingPreferredPhotoDetails', error);
    dispatch({ type: LOAD_LISTING_PREFERRED_PHOTO_DETAILS_FAIL });
  }
};

/*
 Retrieves the listing photo by using a photo identifier which can be either
   a file URL of form: https://[bucket-name].s3.[s3-region].amazonaws.com/[file-name],
   or a file name
*/
const loadListingPhoto = photoUrlOrFileName => async dispatch => {
  dispatch({ type: LOAD_LISTING_PHOTO });
  try {
    const listingPhoto = await apiService.Photos.getSingleImage(photoUrlOrFileName);
    dispatch({
      type: LOAD_LISTING_PHOTO_SUCCESS,
      payload: listingPhoto,
    });
  } catch (error) {
    console.error('Error: Listing loadListingPhoto', error);
    dispatch({ type: LOAD_LISTING_PHOTO_FAIL });
  }
};

const loadListingPhotoSortOrder = arrayOfKeys => ({
  type: LOAD_LISTING_PHOTO_SORTORDER,
  payload: arrayOfKeys,
});

const clearListingPhotoSortOrder = () => ({
  type: CLEAR_LISTING_PHOTO_SORTORDER,
});
/*
  Dispatch to load results from a tax auto pop search
  On success, results are stored in redux as autoPopListings
*/
const loadTaxSearchResults = taxData => async dispatch => {
  dispatch({ type: TAX_AUTO_POP_SEARCH });
  try {
    const autoPopListings = await apiService.Listing.TaxAutoPopSearch(taxData);
    dispatch({ type: TAX_AUTO_POP_SEARCH_SUCCESS, payload: { autoPopListings } });
  } catch (error) {
    console.error('Error: Listing loadTaxSearchResults', error);
    dispatch({ type: TAX_AUTO_POP_SEARCH_FAIL });
  }
};

const loadListingSearchResults = listingData => async dispatch => {
  dispatch({ type: SEARCH_LISTINGS });
  try {
    const listingSearchResults = await apiService.Listing.SearchListings(listingData);
    dispatch({ type: SEARCH_LISTINGS_SUCCESS, payload: { listingSearchResults } });
  } catch (error) {
    console.error('Error: Listing loadListingSearchResults', error);
    dispatch({ type: SEARCH_LISTINGS_FAIL });
  }
};

const reloadListingClicked = listingData => async dispatch => {
  dispatch({ type: RELOAD_LISTING_CLICKED });
  try {
    const [listingSearchResults] = await apiService.Listing.SearchListings(listingData);
    dispatch({
      type: RELOAD_LISTING_CLICKED_SUCCESS,
      payload: { listingSearchResults },
    });
  } catch (error) {
    console.error('Error: Listing reloadListingClicked', error);
    dispatch({ type: RELOAD_LISTING_CLICKED_FAIL });
  }
};

/*
  Dispatch for a selected listing from tax auto pop table
  On success, the listing is stored in redux as autoPopSelected
*/
const loadTaxAutoPopSelected = listingData => async dispatch => {
  dispatch({ type: TAX_AUTO_POP_SELECT });
  try {
    const autoPopSelected = await apiService.Listing.TaxAutoPopSelect(listingData);
    // This is needed to transform the data to the same as loadListingById
    const listingSelected = {};
    if (autoPopSelected.length > 0) {
      const [currentListing] = autoPopSelected;
      listingSelected.listing = { ...currentListing };
    }
    dispatch({
      type: TAX_AUTO_POP_SELECT_SUCCESS,
      payload: { listingSelected },
    });
  } catch (error) {
    console.error('Error: Listing loadTaxAutoPopSelected', error);
    dispatch({ type: TAX_AUTO_POP_SELECT_FAIL });
  }
};

const checkForAutoSave = autoSaveCriteria => async dispatch => {
  dispatch({ type: CHECK_AUTOSAVE_LISTING });
  try {
    const result = await apiService.AutoSave.checkAutoSave(autoSaveCriteria);
    dispatch({
      type: CHECK_AUTOSAVE_LISTING_SUCCESS,
      payload: { autoSaveExists: result.listingHasAutosave, autoSaveData: result.data },
    });
  } catch (error) {
    console.error('Error: Listing checkForAutoSave', error);
    dispatch({ type: CHECK_AUTOSAVE_LISTING_FAIL });
  }
};

/*
  This may potentially overwrite the listing data of an edited listing
*/
const loadAutoSave = autoSaveCriteria => async dispatch => {
  dispatch({ type: LOAD_AUTOSAVE_LISTING });
  try {
    const result = await apiService.AutoSave.getAutoSaveData(autoSaveCriteria);
    dispatch({
      type: LOAD_AUTOSAVE_LISTING_SUCCESS,
      payload: { listingSelected: result },
    });
  } catch (error) {
    console.error('Error: Listing loadAutoSave', error);
    dispatch({ type: LOAD_AUTOSAVE_LISTING_FAIL });
  }
};

const removeAutoSave = autoSaveCriteria => async dispatch => {
  dispatch({ type: REMOVE_AUTOSAVE_LISTING });
  try {
    await apiService.AutoSave.removeAutoSaveData(autoSaveCriteria);
    dispatch({ type: REMOVE_AUTOSAVE_LISTING_SUCCESS });
  } catch (error) {
    console.error('Error: Listing removeAutoSave', error);
    dispatch({ type: REMOVE_AUTOSAVE_LISTING_FAIL });
  }
};

const saveAutoSave = autoSaveData => async dispatch => {
  dispatch({ type: SAVE_AUTOSAVE_LISTING });
  try {
    await apiService.AutoSave.autoSave(autoSaveData);
    dispatch({ type: SAVE_AUTOSAVE_LISTING_SUCCESS });
    return true;
  } catch (error) {
    console.error('Error: Listing saveAutoSave', error);
    dispatch({ type: SAVE_AUTOSAVE_LISTING_FAIL });
    return false;
  }
};

const updateAutoSave = autoSaveData => async dispatch => {
  dispatch({ type: UPDATE_AUTOSAVE_LISTING });
  try {
    await apiService.AutoSave.updateAutoSaveData(autoSaveData);
    dispatch({ type: UPDATE_AUTOSAVE_LISTING_SUCCESS });
    return true;
  } catch (error) {
    console.error('Error: Listing updateAutoSave', error);
    dispatch({ type: UPDATE_AUTOSAVE_LISTING_FAIL });
    return false;
  }
};

const toggleShowBrokerListings = value => ({
  type: TOGGLE_SHOW_BROKER_LISTINGS,
  payload: value,
});

export {
  checkForAutoSave,
  clearRepeatableSectionCount,
  clearListingPhotoSortOrder,
  deleteSupplement,
  loadAutoSave,
  removeAutoSave,
  saveAutoSave,
  updateAutoSave,
  loadMyListings,
  loadListingById,
  loadListingToCopyById,
  loadListingPhoto,
  loadListingPreferredPhotoDetails,
  loadListingPhotoSortOrder,
  loadListingSearchResults,
  loadTaxAutoPopSelected,
  loadTaxSearchResults,
  postCurrentImages,
  reloadListingClicked,
  reorderSupplements,
  saveCurrentCoordinates,
  saveCurrentImages,
  saveListingImages,
  saveSupplement,
  setRepeatableSectionCount,
  setSearchCriteria,
  viewListing,
  setUploadsCounter,
  setIsBusy,
  toggleShowBrokerListings,
  RELOAD_LISTING_CLICKED_SUCCESS,
  VIEW_LISTING_CLICKED,
};
